export const FireMethod = {
  classicalFire: 'classicalFire',
  dieWithZero: 'dieWithZero',
} as const;

export type FireMethod = (typeof FireMethod)[keyof typeof FireMethod];

export const WithdrawalTiming = {
  beginningOfYear: 'beginningOfYear',
  twicePerYear: 'twicePerYear',
  endOfYear: 'endOfYear',
} as const;

export type WithdrawalTiming =
  (typeof WithdrawalTiming)[keyof typeof WithdrawalTiming];

export const EventKind = {
  income: 'income',
  extraExpense: 'extraExpense',
} as const;

export type EventKind = (typeof EventKind)[keyof typeof EventKind];

export const EventFrequency = {
  monthly: 'monthly',
  yearly: 'yearly',
} as const;

export type EventFrequency =
  (typeof EventFrequency)[keyof typeof EventFrequency];

export const ScenarioPhase = {
  mvp: 'mvp',
  area2: 'area2',
  area3: 'area3',
  timing: 'timing',
} as const;

export type ScenarioPhase = (typeof ScenarioPhase)[keyof typeof ScenarioPhase];

export const CalculationMode = {
  byRetirementAge: 'byRetirementAge',
  byMonthlyContribution: 'byMonthlyContribution',
} as const;

export type CalculationMode =
  (typeof CalculationMode)[keyof typeof CalculationMode];

export const CALCULATION_MODE_DEFAULT: CalculationMode =
  CalculationMode.byRetirementAge;

export const FIRE_METHODS: readonly FireMethod[] = Object.values(
  FireMethod,
) as FireMethod[];

export const PensionType = {
  standard: 'standard',
  early: 'early',
  late: 'late',
  bridge: 'bridge',
  none: 'none',
} as const;

export type PensionType = (typeof PensionType)[keyof typeof PensionType];

// Czech display names for PensionType
export const PENSION_TYPE_LABELS: Record<PensionType, string> = {
  [PensionType.standard]: 'Starobní důchod',
  [PensionType.early]: 'Předčasný starobní důchod',
  [PensionType.late]: 'Pozdní starobní důchod',
  [PensionType.bridge]: 'Předdůchod',
  [PensionType.none]: '',
};